import React, { Component } from 'react';
import { TextInput } from '../../form-group';
import SelectInput from '../../form-group/SelectInput';
// import PropTypes from 'prop-types';

import './PromoCode.scss';

interface CustomProps {
  promotion?: any;
  amount?: number;
  removeButtonText?: string;
  showRemoveButton?: boolean;
  showPromoCodeBox?: boolean;
  referralApplyText?: string;
  course?: any;
  referralCode?: any;
  onClick: (value: string, referralType: string) => void;
  onRemoveReferral: (value: string) => void;
  referralType: any;
  referralError?: string;
}

interface CustomState {
  value: any;
  referralType: any;
}

class PromoCode extends Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    referralCode: '',
  };

  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: props.referralCode || '',
      referralType: props.referralType || 'customer',
    };
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onRemoveReferral = this.onRemoveReferral.bind(this);
  }

  onClick() {
    const referralCode = this.state.value;
    const referralType = this.state.referralType;
    if (referralCode && referralCode !== '') {
      this.props.onClick(referralCode, referralType);
    }
  }

  onRemoveReferral() {
    const referralCode = this.state.value;
    this.props.onRemoveReferral(this.props.referralCode);
    this.setState({ value: '' });
  }

  onChange(value: string) {
    this.setState({ value });
  }

  changeReferralType(value: string) {
    this.setState({ referralType: value });
  }

  renderReferranceCodeBox() {
    const referralCode = this.state.value;
    const { referralCode: appliedCode, referralError } = this.props;
  
    return (
      <div className="relative">
        <TextInput
          placeholder="Enter Referral Code"
          className={'form-control ltr:pr-20 rtl:pl-20'}
          onChange={(val: string) => this.onChange(val)}
          default={referralCode}
          disabled={appliedCode}
        />
        {appliedCode && this.referralRemoveButton()}
        {!appliedCode && this.referralApplyButton()}
        {/* ❗️ Show error directly below input */}
        {referralError && (
          <p className="text-red-500 text-xs mt-1">
            {referralError}
          </p>
        )}
      </div>
    );
  }
  

  referralApplyButton() {
    return (
      <div className="ApplyCoupon__btn">
        <button
          type="button"
          className="btn btn-primary px-4 py-3 absolute top-1 ltr:right-1 rtl:left-1"
          onClick={() => this.onClick()}
        >
          {this.props.referralApplyText || 'Apply'}
        </button>
      </div>
    );
  }

  referralRemoveButton() {
    return (
      <div className="ApplyCoupon__btn">
        <button
          type="button"
          className="btn btn-primary py-0 px-4 h-[88%] absolute ltr:right-[3px] rtl:left-[3px] top-[7%] text-sm"
          onClick={() => this.onRemoveReferral()}
        >
          Remove
        </button>
      </div>
    );
  }

  render() {
    return (
      <>
        <div className="grid grid-cols-2 gap-x-3">
          <div className="col-span-2 md:col-span-1">
            <SelectInput
              className="form-control-select"
              label=""
              placeholder="Select"
              data={[
                { _id: 'customer', name: 'Referral code' },
                // { _id: 'staff', name: 'Employee code' },
              ]}
              optionLabel="name"
              optionValue="_id"
              default={this.props.referralType || 'customer'}
              disabled={this.props.referralCode && this.props.referralCode}
              onChange={(value: string) => this.changeReferralType(value)}
            />
          </div>
          <div className="col-span-2 md:col-span-1 md:ml-3">
            {this.renderReferranceCodeBox()}
          </div>
        </div>
      </>
    );
  }
  
}

export default PromoCode;
